import { PublicClientApplication } from '@azure/msal-browser';

const clientId = 'fdd9d61d-f867-4bfa-8c43-28941ee664f1'; // SOSvolaris Web 
export const msalInstance = new PublicClientApplication({
    auth: {
        clientId, 
        authority: 'https://login.microsoftonline.com/organizations',
        redirectUri: `${window.location.origin}/auth/callback`,
        navigateToLoginRequestUrl: false
    },
    cache: { cacheLocation: 'sessionStorage' },
});

export const msalInit = msalInstance.initialize(); // IMPORTANT: initialize once and export the promise

export const loginRequest = {
    scopes: [
        'openid',
        'profile',
        'email',
        'api://e3693a7e-8011-4d2c-b39d-3581f72e4f52/access_as_user', // SOSvolaris API scope
    ],
};

export async function getFreshIdpAccessToken(opts = {}) {
    await msalInit; // ensure MSAL is initialized
    const accounts = msalInstance.getAllAccounts();
    if (!accounts.length) return null;

    const request = { ...loginRequest, account: accounts[0], forceRefresh: !!opts.forceRefresh };

    let result = await msalInstance.acquireTokenSilent(request);

    const minValiditySec = opts.minValiditySec ?? 300; // 5 minutes
    const now = Date.now() / 1000;
    const exp = result.expiresOn ? (result.expiresOn.getTime() / 1000) : 0;
    if (!opts.forceRefresh && exp && (exp - now) < minValiditySec) {
        result = await msalInstance.acquireTokenSilent({ ...request, forceRefresh: true });
    }

    return result.accessToken;
}

export async function logoutSSO() {
    await msalInit; // ensure MSAL is initialized
    const account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
    if (!account) return;
    msalInstance.setActiveAccount(null);
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const key = sessionStorage.key(i);
      if (key && (key.startsWith('msal.') || key.includes(clientId))) sessionStorage.removeItem(key);
    }
} 